// utils/exifUtils.ts
import EXIF from 'exif-js';
import { convertDMSToDD } from '../ImageUtils';
import { ExifData } from '../Types';
import { getGeographicAreaFromCoordinates } from 'src/utils';

export const extractExifData = async (file: File): Promise<ExifData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async () => {
      const image = new Image();
      image.src = reader.result as string;

      image.onload = async () => {
        EXIF.getData(image as any, async function() {
          try {
            const lat = EXIF.getTag(this, 'GPSLatitude');
            const lon = EXIF.getTag(this, 'GPSLongitude');
            const latRef = EXIF.getTag(this, 'GPSLatitudeRef');
            const lonRef = EXIF.getTag(this, 'GPSLongitudeRef');
            const exif = EXIF.pretty(this);

            // Extract date information - try multiple EXIF date fields
            let dateTime = EXIF.getTag(this, 'DateTimeOriginal') || 
                          EXIF.getTag(this, 'DateTime') || 
                          EXIF.getTag(this, 'DateTimeDigitized');
            
            // Convert EXIF date format (YYYY:MM:DD HH:MM:SS) to JS Date
            let dateTaken = null;
            if (dateTime) {
              // Replace colons in date portion with dashes for better compatibility
              const [date, time] = dateTime.split(' ');
              const formattedDateTime = date.replace(/:/g, '-') + ' ' + (time || '00:00:00');
              dateTaken = new Date(formattedDateTime);
              
              // If date is invalid, set to null
              if (isNaN(dateTaken.getTime())) {
                dateTaken = null;
              }
            }

            if (lat && lon && latRef && lonRef) {
              const latitude = convertDMSToDD(lat, latRef);
              const longitude = convertDMSToDD(lon, lonRef);
              const area = await getGeographicAreaFromCoordinates(latitude, longitude);
              
              resolve({
                latitude,
                longitude,
                area,
                hasExif: true,
                exif,
                dateTaken
              });
            } else {
              resolve({ 
                hasExif: false, 
                exif,
                dateTaken 
              });
            }
          } catch (error) {
            reject(new Error('Failed to process EXIF data'));
          }
        });
      };

      image.onerror = () => reject(new Error('Failed to load image'));
    };

    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
};